import PaymentDetailsModal from './PaymentDetailsModal';

export default PaymentDetailsModal;
